import { render, staticRenderFns } from "./SettingControls.vue?vue&type=template&id=e7e297d6&lang=pug&"
import script from "./SettingControls.vue?vue&type=script&lang=js&"
export * from "./SettingControls.vue?vue&type=script&lang=js&"
import style0 from "./SettingControls.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports